import { IActivityAction } from '@models/actions/IBaseAction';
import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { IActivityBatchEditingTableProps } from './IActivityBatchEditingTableProps';
import { ActivityBatchEditingTableModal } from './ActivityBatchEditingTableModal';

export const ActivityBatchEditingTableExecutor = createActivityModalExecutor<IActivityBatchEditingTableProps>({
    modal: ActivityBatchEditingTableModal,
    defaultModalSize: 'max',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        displayName: action.displayName,
        actionKey: action.key ?? '',
        actId: getActivityIdFromCompositeId(objId),
        docId: (action as IActivityAction).docId,
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
